"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propsToStyle = exports._s = exports.styleSet = exports.globalStyleInstance = void 0;
var commonStyle_1 = require("./commonStyle");
var styleProperties = ['alignContent', 'alignItems', 'alignSelf', 'aspectRatio', 'backfaceVisibility', 'backgroundColor', 'borderBottomColor', 'borderBottomLeftRadius', 'borderBottomRightRadius', 'borderBottomWidth', 'borderColor', 'borderLeftColor', 'borderLeftWidth', 'borderRadius', 'borderRightColor', 'borderRightWidth', 'borderStyle', 'borderTopColor', 'borderTopLeftRadius', 'borderTopRightRadius', 'borderTopWidth', 'borderWidth', 'bottom', 'color', 'decomposedMatrix', 'direction', 'display', 'elevation', 'flex', 'flexBasis', 'flexDirection', 'flexGrow', 'flexShrink', 'flexWrap', 'fontFamily', 'fontSize', 'fontStyle', 'fontVariant', 'fontWeight', 'height', 'includeFontPadding', 'justifyContent', 'left', 'letterSpacing', 'lineHeight', 'margin', 'marginBottom', 'marginHorizontal', 'marginLeft', 'marginRight', 'marginTop', 'marginVertical', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'opacity', 'overflow', 'overlayColor', 'padding', 'paddingBottom', 'paddingHorizontal', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingVertical', 'position', 'right', 'rotation', 'scaleX', 'scaleY', 'shadowColor', 'shadowOffset', 'shadowOpacity', 'shadowRadius', 'textAlign', 'textAlignVertical', 'textDecorationColor', 'textDecorationLine', 'textDecorationStyle', 'textShadowColor', 'textShadowOffset', 'textShadowRadius', 'tintColor', 'top', 'transform', 'transformMatrix', 'translateX', 'translateY', 'width', 'writingDirection', 'zIndex'];
var GlobalStyle = (function () {
    function GlobalStyle() {
        var _this = this;
        this.MAIN_COLOR = '#000000';
        this.additionStyles = {};
        this.styleHooks = {};
        this.setAdditionStyles = function (styles) {
            if (typeof styles !== 'object')
                throw new Error('setAdditionStyles must use object as object of styles');
            _this.additionStyles = styles;
        };
        this.setStyleHooks = function (hooks) {
            _this.styleHooks = hooks;
        };
    }
    GlobalStyle.prototype.setMainColor = function (color) {
        this.MAIN_COLOR = color;
    };
    return GlobalStyle;
}());
exports.globalStyleInstance = new GlobalStyle();
var dynamicStyle = function () { return ({
    bgMain: {
        backgroundColor: exports.globalStyleInstance.MAIN_COLOR,
    },
    colorMain: {
        color: exports.globalStyleInstance.MAIN_COLOR,
    },
    borderColorMain: {
        borderColor: exports.globalStyleInstance.MAIN_COLOR,
    },
}); };
var commonStyleSheet = function () { return (__assign(__assign(__assign({}, dynamicStyle()), commonStyle_1.commonStyle), exports.globalStyleInstance.additionStyles)); };
var styleSet = function (name) {
    if (!!dynamicStyle()[name])
        return dynamicStyle()[name];
    if (!!commonStyle_1.commonStyle[name])
        return commonStyle_1.commonStyle[name];
    return {};
};
exports.styleSet = styleSet;
exports._s = exports.styleSet;
var hasNumber = function (myString) {
    return /\d/.test(myString);
};
var styleHooks = function (key, value) {
    var hookFunction = exports.globalStyleInstance.styleHooks[key];
    if (hookFunction)
        return hookFunction(value);
    return value;
};
var propsToStyle = function (props) {
    var _a;
    if (props === void 0) { props = {}; }
    var style = {};
    for (var key in props) {
        if (styleProperties.includes(key))
            style[key] = styleHooks(key, props[key]);
        else if (hasNumber(key)) {
            var matchArr = key.match(/\d+/g);
            if (matchArr != null && matchArr.length === 1 && key.indexOf(matchArr[0]) === key.length - matchArr[0].length) {
                var numberValue = Number(matchArr[0]);
                var propertyValue = key.substring(0, key.indexOf(matchArr[0]));
                if (styleProperties.includes(propertyValue)) {
                    var styleObject = (_a = {}, _a[propertyValue] = styleHooks(propertyValue, numberValue), _a);
                    style = Object.assign(style, styleObject);
                }
            }
        }
    }
    for (var key in commonStyleSheet()) {
        if (!!props[key]) {
            style = Object.assign(style, commonStyleSheet()[key]);
            for (var property in style) {
                style[property] = styleHooks(property, style[property]);
            }
        }
    }
    return style;
};
exports.propsToStyle = propsToStyle;
//# sourceMappingURL=globalProps.js.map